import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';


function UpdateChurnedStoresWorkflowTaskService(token, data) {
    return axios.post(`${CURRENT_API_URL}/swhelpdesk/UpdateChurnedStoresWorkflowTask`,data,{

        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("All Workflow Tasks for Churned Stores has been Updated successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while  Updating Workflow Task for Churned Stores. please try again later.");
        return false;
    });
}

export default UpdateChurnedStoresWorkflowTaskService
;